// Lot 564 — mémoire du dernier canal de connexion utilisé AVEC SUCCÈS sur cet appareil (localStorage) :
// par compte (identifiant tapé, e-mail et numéro connus) avec repli sur le dernier canal tous comptes confondus.
// Cette mémoire passe AVANT le moyen préféré du compte (réglage) ; le réglage sert quand l'appareil n'a rien.
export const METHOD_MEMORY_KEY = "yalola.lastLoginMethod";
const METHODS = ["whatsapp", "email_code", "password"];

const normKey = (k) => (typeof k === "string" ? k.trim().toLowerCase() : "");

const read = () => {
  try {
    const v = JSON.parse(localStorage.getItem(METHOD_MEMORY_KEY) || "null");
    return v && typeof v === "object" ? { byAccount: v.byAccount || {}, last: METHODS.includes(v.last) ? v.last : "" } : { byAccount: {}, last: "" };
  } catch { return { byAccount: {}, last: "" }; }
};

export const rememberLoginMethod = (keys, method) => {
  if (!METHODS.includes(method)) return;
  const mem = read();
  (Array.isArray(keys) ? keys : [keys]).map(normKey).filter(Boolean).forEach((k) => { mem.byAccount[k] = method; });
  mem.last = method;
  // Garde-fou : au plus 20 comptes mémorisés (les plus anciens sortent).
  const entries = Object.entries(mem.byAccount);
  if (entries.length > 20) mem.byAccount = Object.fromEntries(entries.slice(-20));
  try { localStorage.setItem(METHOD_MEMORY_KEY, JSON.stringify({ ...mem, at: Date.now() })); } catch { /* noop */ }
};

export const recallLoginMethod = (...keys) => {
  const mem = read();
  for (const k of keys.map(normKey).filter(Boolean)) if (mem.byAccount[k]) return mem.byAccount[k];
  return mem.last || "";
};

export const forgetLoginMethods = () => { try { localStorage.removeItem(METHOD_MEMORY_KEY); } catch { /* noop */ } };

// Réordonne la liste du serveur : le canal mémorisé passe en tête (marqué `last_used`) ; sinon l'ordre du serveur
// (moyen préféré du compte d'abord, puis WhatsApp, code e-mail, mot de passe) est conservé.
export const orderLoginMethods = (methods, remembered) => {
  if (!Array.isArray(methods)) return methods;
  const idx = remembered ? methods.findIndex((m) => m && m.method === remembered) : -1;
  if (idx < 0) return methods;
  const hit = { ...methods[idx], last_used: true };
  return [hit, ...methods.filter((_, i) => i !== idx)];
};
